import { postContent } from './api-helper';

const checkPermissionUrl = `${process.env.REACT_APP_RESOURCE_MANAGER_API}/check`;

export const checkPermission = (actionsKeys = []) => {
  return postContent(`${checkPermissionUrl}`, { actionsKeys });
};
